<!-- <div class="nav-main content-web-section" > -->
  <div
  #modalContainer
  class="nav-main content-web-section"
  role="dialog"
  aria-modal="true"
  aria-labelledby="menuDialogTitle"
  tabindex="-1">

    <h2 id="menuDialogTitle" class="sr-only">
        Navigation Menu
    </h2>
    <!-- <img src="assets/images/close.png" class="close-button cursor-pointer" (click)="closePop()"> -->
     <button
    type="button"
    class="close-button"
    aria-label="Close menu"
    (click)="closePop()">

    <img
        src="assets/images/close.png"
        alt="">
</button>
<nav aria-label="Primary navigation">
    <ul class="menus">
        <li class="cursor-pointer">
          <!-- <a (click)="accountStatements()">Account Statements</a> -->
           <a
              href="https://mfs.kfintech.com/investor/General/StatementsAndReports"
              target="_blank"
              rel="noopener noreferrer">
              Account Statements
            </a>
        </li>
      <ng-container *ngFor="let item of menuItems">
        <li  *ngIf="!item?.disabled" class="cursor-pointer" >
          <a [routerLink]="[item.url]" (click)="navPage()">{{item.displayName}}</a>
      </li>
    </ng-container>
            <!-- <br><br><br><br><br> -->
    </ul>
</nav>

</div>

<!-- <div class="nav-main nav-main-mobile content-mobile-section" > -->
 <div
  #modalContainer
  class="nav-menu-wrapper"
  role="dialog"
  aria-modal="true"
  aria-labelledby="menuDialogTitleMobile"
  tabindex="-1">

    <h2 id="menuDialogTitleMobile" class="sr-only">
        Navigation Menu
    </h2>
  <!-- <img src="assets/images/close.png" class="close-button cursor-pointer" (click)="closePop()"> -->
   <button
    type="button"
    class="close-button"
    aria-label="Close menu"
    (click)="closePop()">

    <img
        src="assets/images/close.png"
        alt="">
</button>
<nav aria-label="Primary navigation">
  <ul class="menus">
    <ng-container *ngFor="let item of menuItems">
      <li *ngIf="!item?.disabled" class="cursor-pointer">
        <a [routerLink]="[item.url]" (click)="navPage()">{{item.displayName}}</a>
    </li>
  </ng-container>
          <br><br><br><br><br>
  </ul>
</nav>
</div>
